import { render, staticRenderFns } from "./book-detail-dialog.vue?vue&type=template&id=85c65e1c&scoped=true"
import script from "./book-detail-dialog.vue?vue&type=script&lang=ts"
export * from "./book-detail-dialog.vue?vue&type=script&lang=ts"
import style0 from "./book-detail-dialog.vue?vue&type=style&index=0&id=85c65e1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c65e1c",
  null
  
)

export default component.exports